<ng-container *transloco="let t; read: 'teamsBanner'">
  <ng-container *rmaLet="showContactForm$ as showContactForm">
    <ng-container *ngIf="cardFooter; else banner">
      <div class="footer-container">
        <img class="footer-img-container" alt="" [src]="teamImage | staticAsset" />
        <div class="text-container">
          <span class="footer-heading">{{ t('title', { name: name }) }}</span>
          <span class="footer-description">{{ showContactForm ? t('description.checkout') : t('description.checkout-organic') }}</span>
          <ng-container *ngIf="showContactForm; else organic">
            <a mat-button color="primary" class="link-button" [href]="teamUrl">
              {{ t('button') }} <rma-icon glyph="call_made" matButtonIcon />
            </a>
          </ng-container>
          <ng-template #organic>
            <a mat-button color="accent" class="link-button" routerLink="/billing/checkout/team">
              <ng-container *ngIf="trialPeriodDays$ | async as trialPeriodDays; else upgrade">
                {{ t('button-organic-trial', { trialPeriodDays: trialPeriodDays }) }}
              </ng-container>
              <ng-template #upgrade>
                {{ t('button-organic-upgrade') }}
              </ng-template>
            </a>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <ng-template #banner>
      <ng-container *ngIf="!isDismissed">
        <div class="banner-container">
          <div class="content-container">
            <img class="img-container" alt="" [src]="teamImage | staticAsset" />
            <div class="banner-text">
              <span class="heading">{{ t('title', { name: name }) }}</span>
              <span class="description">{{ showContactForm ? t('description.home') : t('description.home-organic') }}</span>
            </div>
          </div>
          <ng-container *ngIf="showContactForm; else organic">
            <a mat-flat-button class="contact-button" [href]="teamUrl">{{ t('button') }}</a>
          </ng-container>
          <ng-template #organic>
            <a mat-flat-button color="accent" routerLink="/billing/subscription-features" [queryParams]="teamsQueryParams$ | async">
              <ng-container *ngIf="trialPeriodDays$ | async as trialPeriodDays; else upgrade">
                {{ t('button-organic-trial', { trialPeriodDays: trialPeriodDays }) }}
              </ng-container>
              <ng-template #upgrade>
                {{ t('button-organic-upgrade') }}
              </ng-template>
            </a>
          </ng-template>
          <button class="close" mat-icon-button (click)="onClose()" type="button">
            <rma-icon glyph="close" matButtonIcon />
          </button>
        </div>
      </ng-container>
    </ng-template>
  </ng-container>
</ng-container>
